import { InjectorBuilder } from "@uix/common";

/** The injector is responsible for creating instances of service classes. */
export const injector = new InjectorBuilder().build();
